import {
  Button,
  Checkbox,
  DatePicker,
  Input,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import { toastError, toastSuccess } from "helpers/toasters";
import AddCodeModal from "./AddCodeModal";
import Header from "modules/SubComponents/Header";
import SubHeader from "modules/SubComponents/SubHeader";
import moment from "moment";
import {
  addCode,
  deleteCodes,
  getAllCodes,
  searchForCodeDetails,
  getAllPackages,
  getForCodes,
} from "Network";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  DeleteOutlined,
  EyeOutlined,
  FilterOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import DeleteModal from "./DeleteModal";
import { da } from "date-fns/locale";

const { RangePicker } = DatePicker;

function Code() {
  const [loading, setLoading] = useState(true);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [isDelModalLoading, setIsDelModalLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [renderMe, setRenderMe] = useState(false);
  const [codes, setCodes] = useState([]);
  const [searchedColumn, setSearchedColumn] = useState("");
  const [dateRange, setDateRange] = useState([]);
  const [prefexId, setPrefexId] = useState("");
  const [allPackages, setAllPackages] = useState([]);
  const [packageFilter, setPackageFilter] = useState([]);
  const [packageTypes, setPackageTypes] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const [searchVal, setSearchVal] = useState("");

  const {
    authorization: { email: adminEmail, isCeo, isCodesManager },
  } = useSelector((state) => state?.auth);

  // Fetch active packages
  useEffect(() => {
    const getPackagesOnSystem = async () => {
      getForCodes(
        (success) => {
          if (success?.isSuccess) {
            setAllPackages(success.data);
          } else {
            toastError(success.err_msg);
          }
        },
        (fail) => {
          if (fail?.data) {
            toastError(fail.data?.err_msg);
          } else {
            toastError();
          }
        }
      );
    };
    getPackagesOnSystem();
  }, []);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8, display: "flex", flexDirection: "column" }}>
        <Input
          placeholder={`Search...`}
          value={selectedKeys[0]}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
          }}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: "block" }}
        />
        <div className="d-flex justify-content-between">
          <Button
            style={{ width: 90 }}
            onClick={() => {
              clearFilters();
              confirm();
              setRenderMe((value) => !value);
            }}
          >
            Reset
          </Button>
          <Button
            type="primary"
            // onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            style={{ width: 90, display: "flex", alignItems: "center" }}
          >
            Search
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      if (dataIndex === "duration") {
        return record[dataIndex]
          ? record[dataIndex].slice(0, 2).trim().includes(value.toLowerCase())
          : "";
      } else {
        return record[dataIndex]
          ? record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          : "";
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? <span>{text}</span> : text,
  });

  const handleCheckboxChange = (value) => {
    setPackageFilter((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  // Handle date range change
  const handleDateRangeChange = (range) => {
    if (!range || range.length === 0) {
      setDateRange([]);
    } else {
      const from = range?.[0]?.toISOString();
      const to = range?.[1]?.toISOString();
      setDateRange([from, to]);
    }
  };

  const handleResetPackageFilter = (confirm) => {
    setPackageTypes([]);
    confirm();
  };

  const handleSearchPackageFilter = (confirm) => {
    const packageTypes = packageFilter?.map((item) => item?.id);
    setPackageTypes(packageTypes?.length ? packageTypes : []);
    confirm();
  };

  const columns = [
    // COURIER NAME
    {
      title: "COURIER NAME",
      key: "courierName",
      dataIndex: "courierName",
      render: (courierName) => {
        return <div style={{ width: "100px" }}>{courierName}</div>;
      },
      ...getColumnSearchProps("courierName"),
      sorter: (a, b) =>
        (a?.courierName || "").localeCompare(b?.courierName || ""),
    },
    // PREFIX
    {
      title: "PREFIX",
      key: "prefex",
      dataIndex: "prefex",
      ...getColumnSearchProps("prefex"),
      sorter: (a, b) => (a?.prefex || "").localeCompare(b?.prefex || ""),
    },
    // DURATION (PACKAGE TYPE)
    {
      title: "PACKAGE TYPE",
      key: "duration",
      dataIndex: "duration",
      render: (duration) => {
        return <div style={{ width: "150px" }}>{duration}</div>;
      },
      sorter: (a, b) => {
        const getNumericValue = (duration) => {
          const match = duration.match(/(\d+)/); // Extracts the first number from the string
          return match ? parseInt(match[0], 10) : 0; // Defaults to 0 if no number is found
        };
        return (
          getNumericValue(a?.duration || "") -
          getNumericValue(b?.duration || "")
        );
      },

      filterDropdown: ({ confirm }) => {
        return (
          <>
            <div
              className="flex flex-column justify-content-center"
              style={{ padding: "8px" }}
            >
              {allPackages?.map((option) => (
                <Checkbox
                  key={option.id}
                  checked={packageFilter.includes(option)}
                  onChange={() => handleCheckboxChange(option)}
                >
                  {option.packageName}
                </Checkbox>
              ))}
            </div>
            <Row
              style={{
                display: "flex",
                gap: "8px",
                justifyContent: "flex-end",
                padding: "8px",
              }}
            >
              <Button
                size="small"
                onClick={() => handleResetPackageFilter(confirm)}
              >
                Reset
              </Button>
              <Button
                size="small"
                type="primary"
                onClick={() => handleSearchPackageFilter(confirm)}
              >
                Search
              </Button>
            </Row>
          </>
        );
      },

      filterIcon: () => (
        <FilterOutlined
          style={{ color: packageTypes.length > 0 ? "#1890ff" : undefined }}
        />
      ),

      // filters: allPackages?.map((pkg) => {
      //   return { text: pkg?.packageName, value: pkg?.packageName };
      // }),

      // filters: [...new Set(allPackages?.map((pkg) => pkg?.packageName))].map(
      //   (packageName) => ({
      //     text: packageName,
      //     value: packageName,
      //   })
      // ),
      // onFilter: (value, record) => {
      //   console.log(value);
      //   // return record?.duration.indexOf(value) === 0;
      //   return record?.duration === value;
      // },
    },
    // PRICE
    {
      title: "PRICE",
      key: "price",
      dataIndex: "price",
      ...getColumnSearchProps("price"),
      sorter: (a, b) => (a.price > b.price ? 1 : -1),
      render: (price) =>
        price !== undefined && price !== null ? `${price} LE` : "0",
    },
    // TOTAL CODES
    {
      title: "TOTAL CODES",
      key: "codeCount",
      dataIndex: "codeCount",
      ...getColumnSearchProps("codeCount"),
      sorter: (a, b) => (a.codeCount > b.codeCount ? 1 : -1),
    },
    // USED CODES
    {
      title: "USED CODES",
      key: "usedCodesCount",
      dataIndex: "usedCodesCount",
    },
    // UNUSED CODES
    {
      title: "UNUSED CODES",
      key: "usedCodesCount",
      dataIndex: "notUsedCodesCount",
    },
    // TOTAL BENEFIT
    {
      title: "TOTAL BENEFIT",
      key: "totalSalesWithoutBonus",
      dataIndex: "totalSalesWithoutBonus",
    },
    // TOTAL BONUS
    {
      title: "TOTAL BONUS",
      key: "totalBonus",
      dataIndex: "totalBonus",
    },
    // TOTAL SALES
    {
      title: "TOTAL SALES",
      key: "totalSalesWithBonus",
      dataIndex: "totalSalesWithBonus",
    },
    // Creator Admin
    {
      title: "CREATOR ADMIN",
      key: "addedBy",
      dataIndex: "addedBy",
      render: (addedBy) => {
        return <div style={{ width: "100px" }}>{addedBy || "-"}</div>;
      },
    },
    // CREATED AT
    {
      title: "CREATED AT",
      key: "createdAt",
      dataIndex: "createdAt",
      render: (_, record) => {
        if (record?.createdAt) {
          return (
            <div style={{ width: "100px" }}>
              {moment(record.createdAt).format("DD-MM-YYYY")}
            </div>
          );
        } else {
          return <>{"-"}</>;
        }
      },
      filterDropdown: ({ confirm, clearFilters }) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: ".5rem",
            }}
          >
            <RangePicker
              onChange={(dates) => {
                handleDateRangeChange(dates);
              }}
              format="YYYY-MM-DD"
              style={{ margin: "20px 0", width: "100%", margin: "auto" }}
            />
          </div>
        );
      },
      filterIcon: () => (
        <FilterOutlined
          style={{ color: dateRange.length > 0 ? "#1890ff" : undefined }}
        />
      ),
      sorter: (a, b) => (a.createdAt > b.createdAt ? 1 : -1),
    },
    // ACTION
    {
      title: "ACTION",
      key: "action",
      fixed: "right",
      render: (_, record) => (
        <div className="d-flex align-items-center gap-4">
          <Link to={`/code/${record.prefexId || record._id}`}>
            <EyeOutlined />
          </Link>
          {(isCeo || isCodesManager) && (
            <Button
              disabled={!(isCeo || isCodesManager)}
              className="codes__delete-btn"
              icon={<DeleteOutlined style={{ color: "red" }} />}
              onClick={() => {
                setOpen(true);
                setPrefexId(record?.prefexId);
              }}
            />
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    let search = {};

    if (searchValue.length) {
      search = {
        search: searchValue,
      };
    }

    if (dateRange.length > 1) {
      search = {
        from: dateRange[0],
        to: dateRange[1],
      };
    }

    if (packageTypes.length) {
      search = {
        packageTypes,
      };
    }

    if (searchValue.length && dateRange.length > 1 && packageTypes.length) {
      search = {
        search: searchValue,
        from: dateRange[0],
        to: dateRange[1],
        packageTypes,
      };
    }

    let handler;
    const getData = () => {
      setLoading(true);
      // if (searchValue.length) {
      handler = setTimeout(() => {
        getAllCodes(
          (success) => {
            if (success?.isSuccesss) {
              // Reverse the array received from the backend
              setCodes(success.data);
              setLoading(false);
            } else {
              toastError(success.err_msg);
              setLoading(false);
            }
          },
          (fail) => {
            if (fail?.data) {
              setLoading(false);
              toastError(fail.data?.err_msg);
            } else {
              toastError();
              setLoading(false);
            }
          },
          search
        );
      }, 1000);
    };
    getData();

    return () => {
      clearTimeout(handler);
    };
  }, [renderMe, searchValue, dateRange, packageTypes]);

  const handleShowAddCodePopup = () => {
    setIsModalVisible(true);
  };

  const onAddModalCancel = () => {
    setIsModalVisible(false);
  };

  const onDelModalCancel = () => {
    setOpen(false);
    setPrefexId("");
  };

  const handleAddNewCode = (payload) => {
    if (payload) {
      if (!payload?.price) {
        delete payload.price;
      }
      setIsModalLoading(true);
      addCode(
        payload,
        (success) => {
          if (success?.isSuccesss) {
            toastSuccess(success.message);
            setIsModalLoading(false);
            setIsModalVisible(false);
            // setRenderMe((prev) => !prev);
            // window.location.reload();
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            toastError(success.err_msg);
            setIsModalLoading(false);
          }
        },
        (fail) => {
          if (fail?.data) {
            toastError(fail.data?.err_msg);
            setIsModalLoading(false);
          } else {
            toastError();
            setIsModalLoading(false);
          }
        }
      );
    }
  };

  const handleDeleteCodes = () => {
    setIsDelModalLoading(true);
    deleteCodes(
      { prefexId },
      (success) => {
        toastSuccess(success?.data?.message);
        setIsDelModalLoading(false);
        onDelModalCancel();
        // setRenderMe((prev) => !prev);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      },
      (error) => {
        toastError(error?.data?.err_msg);
        setIsDelModalLoading(false);
        onDelModalCancel();
      }
    );
  };

  // Determine table data source
  const getTableDataSource = () => {
    return codes;
  };

  const handleTableChange = (pagination, filters, sorter, extra) => {
    if (extra.currentDataSource) {
      setCodes(extra.currentDataSource); // Update filtered data
    }
  };

  const exportData = getTableDataSource().map((code) => ({
    "courier Name": code.courierName,
    Prefix: code.prefex,
    Duration: code.duration,
    Price: code.price ? `${code.price} LE` : "-",
    "Total Codes": code.codeCount,
    "Used Codes": code.usedCodesCount,
    "Unused Codes": code.notUsedCodesCount,
    "Total Sales": code.totalSalesWithBonus,
    "Total Bonus": code.totalBonus,
    "Total Benefit": code?.totalSalesWithoutBonus,
    "Creator Admin": code.addedBy || "-",
    "Created At": moment(code.createdAt).format("DD-MM-YYYY"),
  }));

  const handleGetSearchValueFromHeader = (value) => {
    setSearchValue(value);
  };

  return (
    <section className="users ">
      <div className="users__all-contents ">
        <div className="users__content">
          <div className="users__usersData">
            <Header
              // searchVal={searchVal?.length > 0 ? searchVal : ""}
              title="Codes"
              plusButtonName="Add Code"
              plusButtonAction={handleShowAddCodePopup}
              exportAsExcel
              columnsForExport={columns}
              reportName={`CODES`}
              dataSource={exportData}
              xlsx
              search="Find code"
              getSearchedFromHeader={handleGetSearchValueFromHeader}
              searchVal={searchVal?.length > 0 ? searchVal : ""}
              disableMe={!(isCeo || isCodesManager)}
            />
            <SubHeader bgColor="red" title={"Codes Data"} />
            <div className="cast-data__table  grid-table ">
              <Table
                onChange={handleTableChange} // Track filtered data
                rowKey={(row) => row?._id}
                className=""
                columns={columns}
                scroll={{ x: "max-content" }}
                dataSource={codes}
                loading={loading}
                rowClassName={(record, index) =>
                  index % 2 === 0 && "background-even-records "
                }
                pagination={{
                  defaultPageSize: "7",
                  responsive: true,
                  hideOnSinglePage: true,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <AddCodeModal
        isModalVisible={isModalVisible}
        SubHeader={
          <SubHeader
            bgColor="red"
            title={"Generate Code"}
            closeButton
            onCancel={onAddModalCancel}
          />
        }
        isModalLoading={isModalLoading}
        onCancel={onAddModalCancel}
        primaryBtnName={"Add"}
        secondaryBtnName={"Cancel"}
        action={handleAddNewCode}
        activePackages={allPackages}
      />
      <DeleteModal
        open={open}
        SubHeader={
          <SubHeader
            bgColor="red"
            title={"Delete Codes"}
            closeButton
            onCancel={onDelModalCancel}
          />
        }
        onCancel={onDelModalCancel}
        handleDeleteCodes={handleDeleteCodes}
        loading={isDelModalLoading}
      />
    </section>
  );
}
export default Code;
